import { render, staticRenderFns } from "./statistics_list.vue?vue&type=template&id=a53de31a&"
import script from "./statistics_list.vue?vue&type=script&lang=js&"
export * from "./statistics_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports